import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from '../rest/authentication.service';

export const authGuard: CanActivateFn = async () => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);
  const token = await authService.getJwtAccessToken();

  return token ? true : router.createUrlTree(['user', 'login']);
};
